import { Pipe, PipeTransform } from '@angular/core';
import { ORDER_STATUS } from '../../../pages/core/models/Order';
import { TransactionStatus } from '../../../pages/core/models/Transactions';
import { WITHDRAW_TRANSACTION_STATUS } from '../../../pages/core/models/FiatTransaction';

@Pipe({
  name: 'historyStatus',
})
export class HistoryStatusPipe implements PipeTransform {
  transform(value: number | string, ...args: string[]): string {
    const status = value;
    const category = args[0];
    if (category === '') return;
    if (category === 'order') {
      switch (status) {
        case ORDER_STATUS.PENDING:
          return 'Pendiente';
        case ORDER_STATUS.COMPLETED:
          return 'Completado';
        case ORDER_STATUS.CANCELLED:
          return 'Cancelado';
        default:
          break;
      }
    }
    if (category === 'transaction') {
      switch (status) {
        case TransactionStatus.AWAITING_OK:
          return 'Pendiente';
        case TransactionStatus.CANCELLED:
          return 'Cancelado';
        case TransactionStatus.CONFIRMED:
          return 'Confirmado';
        case TransactionStatus.PENDING_CONFIRMATIONS:
          return 'Pendiente de confirmaciones';
        case TransactionStatus.REFUNDED:
         return 'Reembolsado'
        default:
          return 'Pendiente';
      }
    }
    if (category === 'withdraw') {
      switch (status) {
        case WITHDRAW_TRANSACTION_STATUS.PENDING:
          return 'Pendiente';
        case WITHDRAW_TRANSACTION_STATUS.EXECUTED:
          return 'Confirmado';
        case WITHDRAW_TRANSACTION_STATUS.FAILED:
          return 'Pendiente';
        case WITHDRAW_TRANSACTION_STATUS.CANCELLED:
          return 'Cancelado';
        case WITHDRAW_TRANSACTION_STATUS.PENDING_ADMIN:
          return 'Pendiente';
        case WITHDRAW_TRANSACTION_STATUS.RETRIED:
          return 'Reintentado';
        default:
          return 'Pendiente';
      }
    }
    return '';
  }
}
